import styled from 'styled-components';

export const LabelsContainer = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;

    @media (max-width: 490px) {
        flex-direction: column;
    }
`;

export const StatusLabel = styled.span<{ isDuplicate: boolean }>`
    --font-size-body: var(--font-size-body-3);
    color: var(--color-primary);
    padding: 5px 10px;
    background: ${(props) => props.isDuplicate
        ? 'var(--label-color-inactive)'
        : 'var(--label-color-active)'};
    border-radius: 5px;
    height: min-content;
    width: fit-content;
`;

export const OfferLabel = styled.span<{ darkerColor?: boolean }>`
    --font-size-body: var(--font-size-body-3);
    color: var(--color-primary);
    padding: 5px 10px;
    background: ${(props) => props.darkerColor
        ? 'var(--label-color-light-darker)'
        : 'var(--label-color-light)'};
    border-radius: 5px;
    height: min-content;
    width: fit-content;
`;

export const ArchivedLabel = styled(OfferLabel)`
    color: var(--color-white);
    background: var(--color-error);
`;
